import React, { useEffect, useState } from 'react';

import { Switch, useHistory, useLocation } from 'react-router-dom';

import { useWindowSize } from 'general/hooks';
import { useAppSelector } from 'redux/store/store.types';

import AppNav from '@components/AppNav/AppNav';

import NibBreadcrumbs from 'components/NibBreadcrumbs/NibBreadcrumbs';

export const Child = ({ children }) => children;

const minWidthForPersistedSidebar = 1280;

const Private = ({ children, publicRoutes, disabledRoutes, nakedRoutes, unprotectedRoutes }) => {
  const { currentUser } = useAppSelector((store) => store.authSession);
  const { navigationLinks } = useAppSelector((store) => store.platform);

  const [isSideBarOpen, setSideBar] = useState(true);
  const [acceptedComponents, setAccepted] = useState([]);
  const [deniedComponents, setDenied] = useState([]);

  const history = useHistory();
  const { pathname } = useLocation();
  const { width } = useWindowSize();

  const pathTable = navigationLinks.reduce((result, link) => {
    result[link.to] = link;
    return result;
  }, {});

  useEffect(() => {
    if (width < minWidthForPersistedSidebar) {
      setSideBar(false);
    }
  }, [pathname, width]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    React.Children.forEach(children, (child) => {
      if (child.props.type === 'Accepted') {
        setAccepted(child.props.children);
      } else if (child.props.type === 'Denied') {
        setDenied(child.props.children);
      }
    });
  }, [children]);

  const haveRights = (basePath, roles) => {
    const route = pathTable['/' + basePath];
    if (route?.unprotected === true) return true;
    if (route && route.roles_allowed) {
      for (let role of roles) {
        if (route.roles_allowed.includes(role.name)) return true;
      }
    }
    return false;
  };

  if (currentUser && !publicRoutes.includes(pathname)) {
    if (nakedRoutes.includes(pathname)) return <Switch>{acceptedComponents}</Switch>;

    const rolesDisabled = !!Number(process.env.REACT_APP_DISABLE_ROLES);
    if (!rolesDisabled) {
      const { hasAdminAccess, roles } = currentUser;
      const firstPathnamePart = pathname.split('/')[1];

      if (
        disabledRoutes.includes(`/${firstPathnamePart}`) ||
        (!unprotectedRoutes.includes(`/${firstPathnamePart}`) &&
          !hasAdminAccess &&
          !haveRights(firstPathnamePart, roles))
      ) {
        history.push(unprotectedRoutes[0]);
      }
    }

    return (
      <>
        <AppNav isSideBarOpen={isSideBarOpen} setSideBar={setSideBar} />
        <main className={isSideBarOpen ? 'withSidebar' : ''}>
          <NibBreadcrumbs />
          <Switch>{acceptedComponents}</Switch>
        </main>
      </>
    );
  } else return <> {deniedComponents}</>;
};

export default Private;
